import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {ToasterService} from "../../../../services/core/toaster.service";
import {CoreService} from "../../../../services/core/core.service";
import {VendorDataService} from "../../vendor/vendor.data.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { finalize, first } from "rxjs/operators";
import {SubcontractorService} from "../subcontractor.service";
import {BackendApiService} from "../../../../services/backend-api.service";
import {STEPPER_GLOBAL_OPTIONS} from "@angular/cdk/stepper";
import {DatePipe} from "@angular/common";
import {MatStepper} from "@angular/material/stepper";
import {ModuleDataMilestoneService} from "../../../../services/module-data-milestone.service";

@Component({
    selector: 'app-create-edit-subcontractor',
    templateUrl: './create-edit-subcontractor.component.html',
    styleUrls: ['./create-edit-subcontractor.component.scss'],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { showError: true },
        },
    ],
    standalone: false
})
export class CreateEditSubcontractorComponent implements OnInit {

  public isEdit:boolean = false;
  @Output() onAdd = new EventEmitter<any>(true);
  public submitted = false;
  public model:any = '';
  public subcontractorFrom!: UntypedFormGroup;
  public step:any;
  public isSaving = false;

  /** Module id of the Subcontractor module — used for milestone auto-deploy. */
  private readonly SUBCONTRACTOR_MODULE_ID = 21;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    public fb: UntypedFormBuilder,
    public toasterService: ToasterService,
    public coreService:CoreService,
    public subcontractorService:  SubcontractorService,
    public backendApiService: BackendApiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CreateEditSubcontractorComponent>,
    public datePipe: DatePipe,
    private moduleDataMilestoneService: ModuleDataMilestoneService,
  ) {
    this.model = this.data?.model;
    this.isEdit = this.data?.isEdit;
  }


  ngOnInit() {
    this.subcontractorFrom = new UntypedFormGroup({
      step01: new UntypedFormGroup({
        addSubcontractor: new UntypedFormControl(null)
      }),
      step02: new UntypedFormGroup({
        subcontractorDetail: new UntypedFormControl(null)
      }),
      step03: new UntypedFormGroup({
        subcontractorContact: new UntypedFormControl(null)
      }),
      step04: new UntypedFormGroup({
        subcontractorCertificates: new UntypedFormControl(null)
      }),
      step05: new UntypedFormGroup({
        addCoveredAreas: new UntypedFormControl(null)
      }),
      step06: new UntypedFormGroup({
        preview: new UntypedFormControl(null)
      }),
    });
  }

  onStepChanged = (event:any, stepper:any) => {
    this.step = {event:event, stepper:stepper};
  }

  close = (data:any = '') => {
    this.dialogRef.close(data);
  }

  onSubmit() {
    if (this.subcontractorFrom.invalid || this.isSaving) {
      return;
    }

    const isCreate = !this.model?.id;
    const service = this.model?.id ? this.backendApiService.patchApi(`subcontractors/${this.model?.id}`,this.getFormData()) : this.backendApiService.postApi('subcontractors/create',this.getFormData())
    this.isSaving = true;
    service
      .pipe(
        finalize(() => {
          this.isSaving = false;
        })
      )
      .subscribe({
        next: (data: any) => {
          if (isCreate) {
            const newSubcontractorId = data?.data?.data?.id;
            if (newSubcontractorId) {
              this.autoDeployMilestones(newSubcontractorId);
            }
          }
          this.close(data?.data?.data);
          this.toasterService.showSuccessMessage(data?.data.message);
          this.subcontractorFrom.reset();
        },
        error: (error: any) => {
          const message = error?.error?.message || 'Unable to save subcontractor. Please try again.';
          this.toasterService.showErrorMessage(message);
        },
      });
  }

  /**
   * After a subcontractor is created, attach the Subcontractor module's auto-deploy
   * milestone template (if one is enabled). Fire-and-forget — failures are logged
   * silently and never block the create flow.
   */
  private autoDeployMilestones(subcontractorId: number) {
    this.moduleDataMilestoneService
      .autoDeploy(this.SUBCONTRACTOR_MODULE_ID, subcontractorId)
      .pipe(first())
      .subscribe({
        next: () => {},
        error: (err) => {
          console.error('Milestone auto-deploy failed for subcontractor', subcontractorId, err);
        }
      });
  }

  changedHandler = (event:any) => {

  }

  getFormData = () => {
    this.makeCertificatesData();
    return {
      name: this.subcontractorFrom?.value?.step01?.addSubcontractor?.name,
      email: this.subcontractorFrom?.value?.step01?.addSubcontractor?.email,
      phone: this.subcontractorFrom?.value?.step01?.addSubcontractor?.phone,
      alternate_phone: this.subcontractorFrom?.value?.step01?.addSubcontractor?.alternate_phone,
      tax_number: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.tax_number,
      fax: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.fax,
      website: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.website,
      state_id: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.address?.state_id?.id,
      address_line_1: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.address?.address_line_1,
      address_line_2: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.address?.address_line_2,
      city: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.address?.city,
      zipcode: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.address?.zipcode,
      billing_state_id: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.billing_address?.state_id?.id,
      billing_address_line_1: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.billing_address?.address_line_1,
      billing_address_line_2: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.billing_address?.address_line_2,
      billing_city: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.billing_address?.city,
      billing_zipcode: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.billing_address?.zipcode,
      shipping_state_id: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.shipping_address?.state_id?.id,
      shipping_address_line_1: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.shipping_address?.address_line_1,
      shipping_address_line_2: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.shipping_address?.address_line_2,
      shipping_city: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.shipping_address?.city,
      shipping_zipcode: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.shipping_address?.zipcode,
      misc_notes: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.misc_notes,
      specific_notes: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.specific_notes,
      has_vehicle: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.has_vehicle,
      can_work_in_state: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.can_work_in_state,
      can_work_out_state: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.can_work_out_state,
      // states: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.states,
      states: this.subcontractorFrom?.value?.step02?.subcontractorDetail?.states ? this.canWorkOutStateIds() : null,
      certificates: this.makeCertificatesData(),
      covered_areas: this.subcontractorFrom?.value?.step05?.addCoveredAreas?.covered_areas ?? null,
      contact: {
        id: this.subcontractorFrom?.value?.step03?.subcontractorContact?.id,
        first_name: this.subcontractorFrom?.value?.step03?.subcontractorContact?.first_name,
        last_name: this.subcontractorFrom?.value?.step03?.subcontractorContact?.last_name,
        email: this.subcontractorFrom?.value?.step03?.subcontractorContact?.email,
        phone: this.subcontractorFrom?.value?.step03?.subcontractorContact?.phone,
        mobile: this.subcontractorFrom?.value?.step03?.subcontractorContact?.mobile,
        job_title: this.subcontractorFrom?.value?.step03?.subcontractorContact?.job_title,
        notes: this.subcontractorFrom?.value?.step03?.subcontractorContact?.notes,
        is_primary: this.subcontractorFrom?.value?.step03?.subcontractorContact?.is_primary,
      },
    }
  }

  touchFormControls(formControlName: string, secondFormControlName: any = null){
    let subcontractorFrom = this.subcontractorFrom.get(formControlName);

    // @ts-ignore
    subcontractorFrom = secondFormControlName ? subcontractorFrom?.get(secondFormControlName) : subcontractorFrom;
    subcontractorFrom?.markAsTouched()
    subcontractorFrom?.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  }


  initChildForm(step: string, formControlName: string, value:any){
    this.subcontractorFrom.get(step)?.get(formControlName)?.setValue(value);

  }

  makeCertificatesData() {
    const certificateArray: any = [];
    const data = this.subcontractorFrom?.value?.step04?.subcontractorCertificates?.certificates;

    data?.map((item: any) => {
      const value = {
        certificate_id: item?.id,
        file: item?.file_id,
        is_selected: item?.is_certified ? 1 : 0,
        expire_at: this.datePipe.transform(item?.expiration_date,'yyyy-MM-dd'),
      }
      certificateArray.push(value);
    })

    return certificateArray;
  }

  canWorkOutStateIds() {
    const states: any = [];
    const data = this.subcontractorFrom?.value?.step02?.subcontractorDetail?.states;
    data?.map((item: any) => {
      states.push({state_id: item?.id});
    })

    return states;
  }
  goBack(stepper: MatStepper) {
    stepper.previous();
  }

}
